import { render, staticRenderFns } from "./DropdownComponent.vue?vue&type=template&id=8e634af2&scoped=true"
import script from "./DropdownComponent.vue?vue&type=script&lang=js"
export * from "./DropdownComponent.vue?vue&type=script&lang=js"
import style0 from "./DropdownComponent.vue?vue&type=style&index=0&id=8e634af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e634af2",
  null
  
)

export default component.exports